const lpuAdInfoLabelNode = document.querySelector('.b-lpu-ad-info-label')

if (lpuAdInfoLabelNode) {
  lpuAdInfoLabelNode.addEventListener('click', event => {
    event.stopPropagation()
  })
}
